// Cross-cutting active-workspace state - kept OUTSIDE React so the axios
// request interceptor can read it without prop drilling. WorkspaceProvider
// mirrors the React active workspace id into this module whenever it changes,
// and pages subscribe via `onWorkspaceChange` to refetch their data when the
// user switches workspaces.

let _activeWorkspaceId = null;
const _listeners = new Set();

export function getActiveWorkspaceId() {
  return _activeWorkspaceId;
}

export function setActiveWorkspaceId(id) {
  const next = id || null;
  if (next === _activeWorkspaceId) return;
  _activeWorkspaceId = next;
  for (const cb of _listeners) {
    try { cb(next); } catch { /* isolate listeners */ }
  }
}

export function onWorkspaceChange(cb) {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
}
